import { CREATE_PROJECT, CREATE_PROJECT_SUCCESS, CREATE_PROJECT_FAILURE, FETCH_PROJECT_LIST, FETCH_PROJECT_LIST_SUCCESS, UPDATE_PROJECT, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAILURE, DELETE_PROJECT, DELETE_PROJECT_SUCCESS, DELETE_PROJECT_FAILURE, BULK_DELETE_PROJECTS, BULK_DELETE_PROJECTS_SUCCESS, BULK_DELETE_PROJECTS_FAILURE } from "./types";

const createProject = (payload) => ({
  type: CREATE_PROJECT, ...payload,
});
const createProjectSuccess = (payload) => ({
  type: CREATE_PROJECT_SUCCESS,
  ...payload
});
const createProjectFailure = () => ({
  type: CREATE_PROJECT_FAILURE
});

const fetchProjectList = (payload) => ({
  type: FETCH_PROJECT_LIST,
  ...payload
});
const fetchProjectListSuccess = (payload) => ({
  type: FETCH_PROJECT_LIST_SUCCESS,
  ...payload
});
const fetchProjectListFailure = () => ({
  type: FETCH_PROJECT_LIST_SUCCESS
});

const updateProject = (payload) => ({
  type: UPDATE_PROJECT,
  ...payload
});
const updateProjectSuccess = (payload) => ({
  type: UPDATE_PROJECT_SUCCESS,
  ...payload
});
const updateProjectFailure = () => ({
  type: UPDATE_PROJECT_FAILURE
});

const deleteProject = (payload) => ({
  type: DELETE_PROJECT,
  ...payload
});
const deleteProjectSuccess = (payload) => ({
  type: DELETE_PROJECT_SUCCESS,
  ...payload
});
const deleteProjectFailure = () => ({
  type: DELETE_PROJECT_FAILURE
});

const bulkDeleteProjects = (payload) => ({
  type: BULK_DELETE_PROJECTS,
  ...payload
});
const bulkDeleteProjectsSuccess = (payload) => ({
  type: BULK_DELETE_PROJECTS_SUCCESS,
  ...payload
});
const bulkDeleteProjectsFailure = () => ({
  type: BULK_DELETE_PROJECTS_FAILURE
});

export {
  createProject, createProjectSuccess, createProjectFailure,
  fetchProjectList, fetchProjectListSuccess, fetchProjectListFailure,
  updateProject, updateProjectSuccess, updateProjectFailure,
  deleteProject, deleteProjectSuccess, deleteProjectFailure,
  bulkDeleteProjects, bulkDeleteProjectsSuccess, bulkDeleteProjectsFailure,
};